// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/LoginImage.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginImage {
  width: 450px;
  height: 721px;
}

h2 {
  color: #da291c;
  font-family: IBMPlexSans;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #da291c;
}

.signIn {
  font-family: IBMPlexSans;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.24;
  letter-spacing: normal;
  text-align: left;
  color: #666 !important;
  margin-top: 10px;
}

.submitbtn {
  width: 50%;
  justify-content: center;
  background-color: var(--cds-button-primary, #da291c);
}

.login {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.loginHeader {
  position: relative;
  left: 0;
  top: 0;
}

.loginImage {
  position: relative;
  top: 0;
  left: 0;
  height: 90vh;
  width: 100%;
}
@media all and (max-width: 834px) {
  .loginImage {
    background: white;
  }
}

.loginLogo {
  position: absolute;
  top: 34px;
  right: 26px;
  height: 10vh;
}

.loginSection {
  position: absolute;
  right: 36%;
  top: 20%;
}
@media all and (max-width: 575px) {
  .loginSection {
    position: absolute;
    right: 0%;
    top: 20%;
  }
}

.loginForm {
  width: 500px;
  margin: 0 auto;
}
@media all and (max-width: 575px) {
  .loginForm {
    width: 350px;
  }
}

.loginFooter {
  display: flex;
  flex-direction: row;
}

.loginAccount {
  font-size: 14px;
  font-weight: 600;
  color: #da291c;
}

.loginSignIn {
  margin-left: auto;
}

.landing-container {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 12%;
}
@media all and (max-width: 834px) {
  .landing-container {
    flex-direction: column-reverse;
    align-items: center;
  }
}

.image-div {
  width: 60%;
  height: 60%;
  object-fit: contain;
}

.content-div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30%;
  height: 307px;
}
@media all and (max-width: 834px) {
  .content-div {
    width: 55%;
    align-items: center;
  }
}

.logo {
  width: 115px;
  height: 58.9px;
  object-fit: contain;
  margin-bottom: 10px;
}

.heading {
  width: 365px !important;
  height: 88px !important;
  font-family: Arial;
  font-size: 31px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
}
@media all and (max-width: 834px) {
  .heading {
    width: 100%;
    height: 100%;
    text-align: center;
  }
}

.btnLogin {
  width: 10%;
  margin-top: 10px;
  height: 49px;
  border-radius: 4px;
  background-color: #025a95;
}

.footer {
  margin-left: 15px;
  margin-right: 15px;
  display: flex;
  flex-direction: column;
}

.footer-section1 {
  width: 97%;
  height: 72px;
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
}

.footer-section2 {
  text-align: center;
  width: 97%;
  height: 14px;
  font-family: Arial;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;EACA,uBAAA;EACA,oDAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yDAAA;EACA,aAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AACF;;AAEA;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AAFF;AALE;EADF;IAEI,iBAAA;EAQF;AACF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAGF;;AAAA;EAME,kBAAA;EACA,UAAA;EACA,QAAA;AAFF;AALE;EADF;IAEI,kBAAA;IACA,SAAA;IACA,QAAA;EAQF;AACF;;AAFA;EAIE,YAAA;EACA,cAAA;AAEF;AANE;EADF;IAEI,YAAA;EASF;AACF;;AAJA;EACE,aAAA;EACA,mBAAA;AAOF;;AAJA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAOF;;AAJA;EACE,iBAAA;AAOF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAOF;AALE;EANF;IAOI,8BAAA;IACA,mBAAA;EAQF;AACF;;AALA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,UAAA;EACA,aAAA;AAQF;AANE;EAPF;IAQI,UAAA;IACA,mBAAA;EASF;AACF;;AANA;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AASF;;AANA;EACE,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AASF;AAPE;EAbF;IAcI,WAAA;IACA,YAAA;IACA,kBAAA;EAUF;AACF;;AAPA;EACE,UAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAUF;;AAPA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAUF;;AAPA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAUF;;AAPA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAUF","sourcesContent":[".loginImage {\n  width: 450px;\n  height: 721px;\n}\n\nh2 {\n  color: #da291c;\n  font-family: IBMPlexSans;\n  font-size: 24px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: left;\n  color: #da291c;\n}\n\n.signIn {\n  font-family: IBMPlexSans;\n  font-size: 20px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.24;\n  letter-spacing: normal;\n  text-align: left;\n  color: #666 !important;\n  margin-top: 10px;\n}\n\n.submitbtn {\n  width: 50%;\n  justify-content: center;\n  background-color: var(--cds-button-primary, #da291c);\n}\n\n.login {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  background-image: url('../../assets/images/LoginImage.png');\n  height: 100vh;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.loginHeader {\n  position: relative;\n  left: 0;\n  top: 0;\n}\n\n.loginImage {\n  @media all and (max-width: '834px') {\n    background: white;\n  }\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 90vh;\n  width: 100%;\n}\n\n.loginLogo {\n  position: absolute;\n  top: 34px;\n  right: 26px;\n  height: 10vh;\n}\n\n.loginSection {\n  @media all and (max-width: '575px') {\n    position: absolute;\n    right: 0%;\n    top: 20%;\n  }\n  position: absolute;\n  right: 36%;\n  top: 20%;\n}\n\n.loginForm {\n  @media all and (max-width: '575px') {\n    width: 350px;\n  }\n  width: 500px;\n  margin: 0 auto;\n}\n\n.loginFooter {\n  display: flex;\n  flex-direction: row;\n}\n\n.loginAccount {\n  font-size: 14px;\n  font-weight: 600;\n  color: #da291c;\n}\n\n.loginSignIn {\n  margin-left: auto;\n}\n\n.landing-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  margin-top: 12%;\n\n  @media all and (max-width: '834px') {\n    flex-direction: column-reverse;\n    align-items: center;\n  }\n}\n\n.image-div {\n  width: 60%;\n  height: 60%;\n  object-fit: contain;\n}\n\n.content-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30%;\n  height: 307px;\n\n  @media all and (max-width: '834px') {\n    width: 55%;\n    align-items: center;\n  }\n}\n\n.logo {\n  width: 115px;\n  height: 58.9px;\n  object-fit: contain;\n  margin-bottom: 10px;\n}\n\n.heading {\n  width: 365px !important;\n  height: 88px !important;\n  font-family: Arial;\n  font-size: 31px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.63;\n  letter-spacing: normal;\n  text-align: left;\n  color: #4a4a4a;\n\n  @media all and (max-width: '834px') {\n    width: 100%;\n    height: 100%;\n    text-align: center;\n  }\n}\n\n.btnLogin {\n  width: 10%;\n  margin-top: 10px;\n  height: 49px;\n  border-radius: 4px;\n  background-color: #025a95;\n}\n\n.footer {\n  margin-left: 15px;\n  margin-right: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-section1 {\n  width: 97%;\n  height: 72px;\n  font-family: Arial;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.71;\n  letter-spacing: normal;\n  text-align: left;\n  color: #4a4a4a;\n}\n\n.footer-section2 {\n  text-align: center;\n  width: 97%;\n  height: 14px;\n  font-family: Arial;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: 0px;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
